import axios from 'axios';
import { CreateLockedPondsInput } from 'views/production-systems/types/locked-ponds/create-locked-ponds-input.type';
import { LockedPonds } from 'views/production-systems/types/locked-ponds/locked-ponds.type';

// POST
// /ewosapi/v1/shrimps/lock-ponds/{siteId}
export const postLockedPonds = async (siteId: string, postLockedPonds: CreateLockedPondsInput): Promise<LockedPonds> => {
  const res = await axios.post<LockedPonds>(`/ewosapi/v1/shrimps/lock-ponds/${siteId}`, postLockedPonds);
  return res.data;
};
